export default __webpack_public_path__ + "static/media/TW_Transparent.e6214a2a.png";